import React from "react";
import { ArrowRight, Building2 } from "lucide-react";
import AdminClientRequestStatusBadge from "./AdminClientRequestStatusBadge";

export type AdminClientRequestCardRow = Record<string, unknown>;

export default function AdminClientRequestCard(props: {
  row: AdminClientRequestCardRow;
  onOpen: (publicId: string) => void;
}): React.JSX.Element {
  const r = props.row;
  const publicId = String(r.publicId ?? "");
  const reference = String(r.reference ?? publicId ?? "");
  const client = r.client as { nomAffiche?: string } | null | undefined;
  const typeLabel = String(r.typeLabel ?? r.type ?? "");
  const status = String(r.status ?? "");
  const statusLabel = String(r.statusLabel ?? status);
  const pri = String(r.priority ?? "");
  const createdAt = String(r.createdAt ?? "");

  return (
    <button
      type="button"
      onClick={() => props.onOpen(publicId)}
      className="group flex w-full flex-col gap-3 rounded-xl border border-white/10 bg-slate-900/80 p-4 text-left shadow-lg shadow-black/20 backdrop-blur transition hover:border-emerald-500/30 hover:bg-slate-900"
    >
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <p className="font-mono text-xs font-bold text-emerald-300/90">{reference}</p>
          <p className="mt-1 flex items-center gap-2 text-sm font-semibold text-white">
            <Building2 className="h-4 w-4 text-slate-500" aria-hidden />
            <span className="truncate">{client?.nomAffiche ?? "Client"}</span>
          </p>
        </div>
        <ArrowRight className="h-4 w-4 shrink-0 text-slate-500 transition group-hover:translate-x-0.5 group-hover:text-emerald-400" />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <span className="rounded-lg border border-white/10 bg-slate-950/80 px-2 py-0.5 text-[11px] font-medium text-slate-300">
          {typeLabel}
        </span>
        {pri ? (
          <span className="rounded-lg border border-amber-500/25 bg-amber-500/10 px-2 py-0.5 text-[11px] font-medium text-amber-200">
            {pri}
          </span>
        ) : null}
        <AdminClientRequestStatusBadge status={status} label={statusLabel} />
      </div>
      <p className="text-[11px] text-slate-500">
        Créé ·{" "}
        {createdAt
          ? new Date(createdAt).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })
          : "—"}
      </p>
    </button>
  );
}
